var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "default-modal",
    {
      attrs: { name: "success-modal" },
      model: {
        value: _vm.modalOpened,
        callback: function($$v) {
          _vm.modalOpened = $$v
        },
        expression: "modalOpened"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "text-center",
          attrs: { slot: "content" },
          slot: "content"
        },
        [
          _c("check-mark"),
          _c("h3", [_vm._v(_vm._s(_vm.title))]),
          _vm.body ? _c("p", [_vm._v(_vm._s(_vm.body))]) : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }